import React from 'react';
import { cn } from '../../design-system/cn';
import { typography } from '../../design-system/tokens';
import SportEmblemDisplay from '../common/SportEmblemDisplay';

/**
 * Canonical matchup sport badge — photoreal sport mark + label from view-model.
 */
export default function MatchupSportBadge({ vm, className, iconOnly = false }) {
  return (
    <span
      data-testid="matchup-sport-badge"
      className={cn(
        typography.micro,
        'inline-flex items-center gap-1 rounded-full border',
        vm.accent.badge,
        className,
      )}
    >
      <SportEmblemDisplay
        iconId={vm.sportIconId}
        size="xs"
        className="!h-5 !w-5"
      />
      {iconOnly ? (
        <span className="sr-only">{vm.sportLabel}</span>
      ) : (
        vm.sportLabel
      )}
    </span>
  );
}
